module.exports = __webpack_public_path__ + "img/st.f0290395.png";